/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

const showFlagResponseMessage = function(success) {
  const $modal = $('#flag-response-modal');
  const $container = $('#flag-response-container', $modal);
  const $message = $('#flag-response-message', $modal);
  const $success_message = $('#flag-response-success-message', $message);
  const $error_message = $('#flag-response-error-message', $message);

  $container.hide();
  $message.show();

  if (success) {
    $success_message.show();
    return $error_message.hide();
  } else {
    $success_message.hide();
    return $error_message.show();
  }
};

root.onFlagResponseSuccess = () => showFlagResponseMessage(true);

root.onFlagResponseError = () => showFlagResponseMessage(false);

root.flagResponse = function(result_id) {
  const $modal = $('#flag-response-modal');
  const $container = $('#flag-response-container', $modal);
  const $message = $('#flag-response-message', $modal);
  const $result_id = $('#flag_result_id', $modal);
  const $options = $('input:radio', $modal);
  const $submit = $('input:submit', $modal);

  $container.show();
  $message.hide();
  $result_id.val(result_id);
  $options.removeAttr('checked');
  $submit.attr('disabled', true);
  return $modal.foundation('open');
};

root.initFlagResponseDialog = function() {
  const $modal = $('#flag-response-modal');
  const $options = $('input:radio', $modal);
  const $submit = $('input:submit', $modal);

  return $options.change(function() {
    $submit.removeAttr('disabled');
  });
};
